import { useApprovalStats } from "@/hooks/useApprovalSystem";
import { Card } from "@/components/ui/card";
import { Clock, CheckCircle, XCircle, ArrowRightLeft } from "lucide-react";

export const ApprovalStatsRow = () => {
  const { data: stats } = useApprovalStats();

  const cells = [
    { label: "Pending", value: stats?.pending ?? 0, icon: Clock, accent: "text-amber-600" },
    { label: "Approved Today", value: stats?.approvedToday ?? 0, icon: CheckCircle, accent: "text-green-600" },
    { label: "Rejected", value: stats?.rejected ?? 0, icon: XCircle, accent: "text-red-600" },
    { label: "Forwarded", value: stats?.forwarded ?? 0, icon: ArrowRightLeft, accent: "text-purple-600" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {cells.map((c) => (
        <Card key={c.label} className="flex items-center gap-3 p-4">
          <c.icon className={`h-5 w-5 ${c.accent}`} />
          <div>
            <p className="text-2xl font-bold">{c.value}</p>
            <p className="text-xs text-muted-foreground">{c.label}</p>
          </div>
        </Card>
      ))}
    </div>
  );
};
